<template>
  <div class="content-container">
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="right"
          label-width="70px"
        >
          <el-form-item label="请求日期">
            <el-date-picker
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="设备">
            <CustomerDeviceSelect
              :customerID="customerID"
              :val="filter.device_id"
              @change="filter.device_id = $event"
            >
            </CustomerDeviceSelect>
          </el-form-item>
        </el-form>
        <div class="mt-10 flex-row-between">
          <div>
            <el-button
              type="primary"
              size="small"
              @click="
                filter.page = 1
                getData()
              "
              >筛选</el-button
            >
            <el-button size="small" @click="reset()">重置</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <el-table
        v-if="!isMobile()"
        :data="quests"
        stripe
        style="width: 100%"
        key="followups2"
        size="mini"
      >
        <el-table-column
          :label="isadealer ? 'NCR编号' : 'NCR编号/最终客户'"
          min-width="150px"
        >
          <template slot-scope="scope">
            <router-link
              :to="
                '/dashboard/service_quests/list/' + scope.row.id + '?origin=0'
              "
              v-if="hasAuth('serviceQuestDetail')"
            >
              {{ scope.row.number }}
            </router-link>
            <template v-if="!isadealer">
              <br />
              {{ scope.row.customer.name }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="设备 / 问题分类" min-width="200">
          <template slot-scope="scope">
            <div>
              {{ scope.row.device.serial_number
              }}<span v-if="scope.row.device.equipment_number"
                >（{{ scope.row.device.equipment_number }}）</span
              >
            </div>
            {{
              scope.row.sub_category
                ? `${scope.row.cmm_category}（${scope.row.sub_category}）`
                : scope.row.cmm_category
            }}
          </template>
        </el-table-column>
        <el-table-column label="发起人" align="center">
          <template slot-scope="scope">{{
            scope.row.user.name || scope.row.customer_user.name
          }}</template>
        </el-table-column>
        <el-table-column label="请求日期" align="center">
          <template slot-scope="scope">
            <span>
              {{ formatTime(scope.row.created_at, 'YYYY-MM-DD HH:mm') }}
            </span>
          </template></el-table-column
        >
        <el-table-column label="负责人" align="center">
          <template slot-scope="scope">
            <template v-if="scope.row.status == 2">
              <span>{{ scope.row.director.name }}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="等待时间" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1 || scope.row.status == 2">
              {{ scope.row.waited_day }}天
            </span>
            <span v-else>-</span>
          </template></el-table-column
        >
        <el-table-column label="状态" align="center" width="140">
          <template slot-scope="scope">
            <template
              v-if="scope.row.approval_id > 0 && scope.row.approve_index == 0"
            >
              <span class="status-tag-border info">待审批</span>
            </template>
            <template v-else>
              <span v-if="scope.row.status == 2" class="status-tag-border info">
                {{
                  scope.row.is_new_flow
                    ? scope.row.current_step.name
                    : ServiceQuestModeStatus[scope.row.mode_status]
                }}
              </span>
              <span v-else>{{ ServiceQuestStatusMap[scope.row.status] }}</span>
            </template>
          </template></el-table-column
        >
        <el-table-column label="操作" align="center" width="80">
          <template slot-scope="scope">
            <router-link
              :to="
                '/dashboard/service_quests/list/' + scope.row.id + '?origin=0'
              "
              v-permission="Auth.serviceQuestDetail"
            >
              <el-button type="primary" size="mini" plain>查看</el-button>
            </router-link>
          </template></el-table-column
        >
      </el-table>
      <ul v-else class="list-style">
        <li v-for="(item, index) in quests" style="align-items: start">
          <div>
            <div
              class="flex-row-between"
              style="height: 20px; line-height: 20px; margin-bottom: 10px"
            >
              <div
                class="flex-row"
                style="line-height: 1.5; align-items: center"
              >
                <span> NCR编号：{{ item.number }} </span>
              </div>
              <router-link
                :to="'/dashboard/service_quests/list/' + item.id + '?origin=0'"
                v-if="hasAuth('serviceQuestDetail')"
              >
                <el-button type="primary" class="text-primary" size="mini" plain
                  >详情</el-button
                >
              </router-link>
            </div>
            <div class="font-12">
              <span>问题分类：</span>
              {{
                item.sub_category
                  ? `${item.sub_category}（${item.cmm_category}）`
                  : item.cmm_category
              }}
            </div>
            <div class="font-12">
              <span>发起人：</span>
              <span>{{ item.user.name || item.customer_user.name }}</span>
            </div>
            <div class="font-12">
              <span>请求日期：</span>
              <span>
                {{ formatTime(item.created_at, 'YYYY-MM-DD HH:mm') }}
              </span>
            </div>
            <div class="font-12">
              <span>负责人：</span>
              <span v-if="item.status == 2">
                {{ item.director.name }}
              </span>
              <span v-else>-</span>
            </div>
            <div class="font-12">
              <span>等待时间：</span>
              <span v-if="item.status == 1 || item.status == 2">
                {{ item.waited_day }}天
              </span>
              <span v-else>-</span>
            </div>
            <div class="font-12">
              <span>状态：</span>
              <template v-if="item.approval_id > 0 && item.approve_index == 0">
                待审批
              </template>
              <template v-else>
                <span v-if="item.status == 2">
                  {{
                    item.is_new_flow
                      ? item.current_step.name
                      : ServiceQuestModeStatus[item.mode_status]
                  }}
                </span>
                <span v-else>{{ ServiceQuestStatusMap[item.status] }}</span>
              </template>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="quests.length == 0 && isMobile()" class="text-info-12">
        暂无数据。
      </div>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { isMobile } from '@/util/index'
import { serviceQuestList } from '../../service/getData'
import { ServiceQuestStatusMap, ServiceQuestModeStatus } from '@/config/global'
import { timeWait } from '@/util'
import { formatTime } from '@/util/index'
import { hasAuth } from '@/permission'
import CustomerDeviceSelect from '@/components/select/customer_device_select'
import store from '@/store/store'

export default {
  components: {
    CustomerDeviceSelect
  },
  props: {
    customerID: {
      type: Number,
      default: 0
    },
    deviceID: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      isadealer: store.getters.userInfo.dealer_id > 0,
      hasAuth,
      isMobile,
      timeWait,
      ServiceQuestStatusMap,
      ServiceQuestModeStatus,
      formatTime,
      quests: [],
      filter: {
        date: null,
        customer_id: null,
        device_id: 0,
        size: 10,
        page: 1
      },
      total: 0
    }
  },

  created () {
    this.filter.device_id = this.deviceID
    this.getData()
  },
  watch: {
    'filter.page': function () {
      this.getData()
    }
  },
  methods: {
    async getData () {
      let data = {
        page: this.filter.page - 1,
        size: this.filter.size,
        customer_id: this.customerID,
        customer_device_id: this.filter.device_id,
        final_customer: true
      }

      if (this.filter.date && this.filter.date.length == 2) {
        data.start_date = this.filter.date[0] || ''
        data.end_date = this.filter.date[1] || ''
      }

      let res = await serviceQuestList(data)
      if (res.code == 0) {
        this.quests = res.data.list
        this.total = res.data.total
      }
    },

    reset () {
      this.filter.date = ''
      this.filter.device_id = 0
      this.filter.page = 1
      this.getData()
    }
  }
}
</script>
